import { motion } from 'framer-motion';
import { forwardRef } from 'react';

const variants = {
  primary: 'bg-gradient-nexus text-nexus-bg-primary font-semibold shadow-glow-mint hover:shadow-glow-mint-lg',
  secondary: 'bg-nexus-bg-tertiary text-nexus-text-primary border border-white/10 hover:bg-nexus-bg-tertiary/80 hover:border-white/20',
  ghost: 'bg-transparent text-nexus-text-primary hover:bg-nexus-bg-tertiary/50',
  danger: 'bg-transparent text-nexus-error border border-nexus-error/30 hover:border-nexus-error hover:shadow-[0_0_15px_rgba(239,68,68,0.3)]',
  outline: 'bg-transparent text-nexus-accent-mint border border-nexus-accent-mint/50 hover:border-nexus-accent-mint hover:shadow-glow-mint',
};

const sizes = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-5 py-2.5 text-sm',
  lg: 'px-6 py-3 text-base',
};

export const NexusButton = forwardRef(({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  isLoading = false,
  disabled = false,
  className = '',
  onClick,
  type = 'button',
  ...props 
}, ref) => {
  return (
    <motion.button
      ref={ref}
      type={type}
      whileHover={{ scale: disabled || isLoading ? 1 : 1.02 }}
      whileTap={{ scale: disabled || isLoading ? 1 : 0.97 }}
      transition={{ type: 'spring', stiffness: 400, damping: 25 }}
      className={`
        relative inline-flex items-center justify-center gap-2
        rounded-sm font-medium tracking-wide
        transition-all duration-200
        focus:outline-none focus:ring-2 focus:ring-nexus-accent-mint focus:ring-offset-2 focus:ring-offset-nexus-bg-primary
        disabled:opacity-50 disabled:cursor-not-allowed
        ${variants[variant]}
        ${sizes[size]}
        ${className}
      `}
      disabled={disabled || isLoading}
      onClick={onClick}
      {...props}
    >
      {isLoading && (
        <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
        </svg>
      )}
      {children}
    </motion.button>
  );
});

NexusButton.displayName = 'NexusButton';
